module.exports = __webpack_public_path__ + "img/jameson-3.9605e984.png";